import { createModal, ModalPopover, NiceModal, useModal } from '@lessonup/ui-components';
import React from 'react';
import { HandleAddImage, ImagePickerModalProps, PickedImageParams } from './ImagePickerModal.types';
import { ImagePickerModalContent } from './ImagePickerModalContent';

export const ImagePickerModal = createModal(
  ({
    modalDirection,
    modalAnchor,
    parentSelector,
    t,
    acceptMultipleFiles,
    initialQuery,
    trackingContext,
  }: ImagePickerModalProps): React.JSX.Element => {
    const modal = useModal();

    const handleAddImage: HandleAddImage = (params) => {
      modal.resolve(params);
      modal.hide();
    };

    return (
      <ModalPopover
        modal={modal}
        contentLabel={t('imagePicker.ariaLabel')}
        onBeforeClose={modal.reject}
        direction={modalDirection}
        modalAnchor={modalAnchor}
        parentSelector={parentSelector}
      >
        <ImagePickerModalContent
          handleAddImage={handleAddImage}
          t={t}
          closeModal={modal.hide}
          acceptMultipleFiles={acceptMultipleFiles}
          initialQuery={initialQuery}
          trackingContext={trackingContext}
        />
      </ModalPopover>
    );
  }
);

export const showImagePickerModal = (props: ImagePickerModalProps): Promise<PickedImageParams> =>
  NiceModal.show(ImagePickerModal, props);
